var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "wrapper",
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "content" }, [
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "shadow" },
              [
                !_vm.errMsg
                  ? [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(" 用户 "),
                        _c("span", { staticClass: "y-fc-4C84FF y-f-b" }, [
                          _vm._v(_vm._s(_vm.currentMobile)),
                        ]),
                        _vm._v(
                          " 邀请您加入他的组织，请点击下方按钮进行确认。 "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "y-t-ac" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "y-mt-20",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleClick },
                            },
                            [_vm._v("确定加入组织")]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _c("div", { staticClass: "text" }, [
                      _vm._v(" " + _vm._s(_vm.errMsg) + " "),
                    ]),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        staticClass: "logoIcon",
        attrs: { src: require("@/assets/images/yto-logo-white.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }